import React, { useMemo } from 'react'
import { useMount } from 'ahooks'
import Udb from '@yy/oneship-udb'
import { UDB_CONF } from '../constants'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from '../store'
import { useHistory } from 'react-router'
import { OneNotification } from '@yy/one-ui'
import { Link } from '@yy/one-icon'
import { getOneClubPath } from '../utils'
import { Toast } from 'antd-mobile'
import Cookies from 'js-cookie'
import { getBaseUserInfo } from '../store/authSlice'
// 所有需要全局通知的都放这里

const pwdSafeUdb = Udb.pwdSafe(UDB_CONF)

/**
 * 密码有效期判断提示
 * @param notification
 */
const usePasswordExpiredNotif = (notification: (data: { url: string }) => void) => {
  const languageStore = useSelector((state) => state?.language)
  const userInfo = useSelector((state) => state.auth.userInfo)
  const uid = useMemo(() => Cookies.get('osudb_uid'), [])
  const dispatch = useDispatch()

  useMount(async () => {
    if (!uid) return
    // 通知提示
    const [pwdRes, user] = await Promise.all([pwdSafeUdb.queryPopup({ uid, ticketType: '1' }), userInfo ?? dispatch(getBaseUserInfo())])
    const day = Math.ceil(pwdRes.data.pwdRemainingTime / (24 * 3600 * 1000))

    if (day < 30 && ![30, 15, 7, 1].includes(day)) {
      const url = getOneClubPath('/user/changePassword', languageStore.lang, {
        email: user.udbUserInfo?.email,
        phone: user.udbUserInfo?.phone,
        source: user.registrySource || 'email',
        uid,
      })
      notification({ url })
    }
  })
}

/**
 * 密码有效期判断提示
 */
export const usePcPasswordExpiredNotif = () => {
  const { t } = useTranslation()
  const history = useHistory()

  usePasswordExpiredNotif((data) => {
    OneNotification.warn({
      message: t('passwordExpired.noti.title'),
      description: (
        <>
          <div style={{ color: '#474F5E' }}>{t('passwordExpired.noti.desc')}</div>
          <div
            style={{
              color: '#356dff',
              fontSize: '14px',
              cursor: 'pointer',
              display: 'inline-block',
            }}
          >
            <span
              onClick={() => {
                history.push(data.url)
              }}
            >
              {t('update.password')}
              <Link style={{ marginLeft: 4 }} />
            </span>
          </div>
        </>
      ),
    })
  })
}

/**
 * 密码有效期判断提示
 */
export const useMobilePasswordExpiredNotif = () => {
  const { t } = useTranslation()

  usePasswordExpiredNotif(() => {
    Toast.show(t('passwordExpired.noti.title'))
  })
}
